import React, { Component } from 'react'
import { Link, } from 'react-router-dom'
import { Alert, } from 'reactstrap'

import RegisterUser from './RegisterWithCode/RegisterUser'
import EnterCode from './RegisterWithCode/EnterCode'

class RegisterWithCode extends Component {
  // Check code form if code not already entered
  // Otherwise, register user

  render() {

    let component = <Alert color='secondary'><i className="fa fa-spinner fa-lg fa-spin"></i> Loading...</Alert>
    if (!this.props.isFetchingCode && this.props.code) {
      component = (
        <RegisterUser 
          code={this.props.code}
          submitCode={this.props.submitCode}
          history={this.props.history}
        />
      )
    } else if (this.props.isFetchingCodeError) {
      component = (
        <Alert color='danger'>
          We had some trouble finding your code. <Link onClick={() => this.props.clearError()} to='/register'>Click here</Link> to try a different code.
        </Alert>
      )
    } else if (!this.props.isFetchingCode && !this.props.code) {
      component = (
        <EnterCode
          submitCode={this.props.submitCode}
          isFetching={this.props.isFetchingCode}
        />
      )
    }

    return (
      <div>{component}</div>
    )
  }
}

export default RegisterWithCode


// WEBPACK FOOTER //
// ./src/components/Users/RegisterWithCode.js